//---------------------------------------------
// Amostras Module 
//---------------------------------------------
// Módulo para gerenciar as ações da amostra

import axios from '../../services/api';
import Cookies from 'js-cookie';
// var qs = require('qs');
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    listCampos: [],
    listCampoMembros: [],
    listCampoFormularios: [],
    listCampoUEs: [],
    listCampoTurmas: [],
    amostraStatusAtiva: false,

    idCampo: Number,
    history: String,

    //ESTADOS PARA ARMAZENAR OS ARRAYS DE PAYLOAD DAS REQUISICOES MANAGE
    payloadManageAplicadores: [],
    payloadManageFormularios: [],
    payloadManageUnidades: [],
    payloadManageTurmas: [],

})

// MUTATIONS
const mutations = {
    
    setHistory(state, payload) {
        state.history = payload
    },

    setIdCampo(state, payload) {
        state.idCampo = payload
    },

    //-- MUTATION REQUISICAO DO LISTCAMPOS/AMOSTRAS
    setListCampos(state, payload) {
        state.listCampos = payload
    },

    //-- MUTATION REQUISICAO DO LISTCAMPOMEMBROS/APLICADORES
    setListCampoMembros(state, payload) {
        state.listCampoMembros = payload
    },

    //-- MUTATION REQUISICAO DO LISTCAMPOFORMULARIOS
    setListCampoFormularios(state, payload) {
        state.listCampoFormularios = payload
    },

    //-- MUTATION REQUISICAO DO LISTCAMPOUNIDADESEDUCACIONAIS
    setListCampoUEs(state, payload) {
        state.listCampoUEs = payload
    },

    //-- MUTATION REQUISICAO DO LISTCAMPOUNIDADESEDUCACIONAIS
    setListCampoTurmas(state, payload) {
        state.listCampoTurmas = payload
    },

    //-- MUTATION ESTADO STATUS AMOSTRA
    setAmostraStatusAtiva(state, payload) {
        state.amostraStatusAtiva = payload
    },

    //-- MUTATION ESTADO DE PAYLOAD MANAGE APLICADORES
    setPayloadManageAplicadores(state, payload) {
        state.payloadManageAplicadores = payload
    },

    //-- MUTATION ESTADO DE PAYLOAD MANAGE FORMULARIOS
    setPayloadManageFormularios(state, payload) {
        state.payloadManageFormularios = payload
    },

    //-- MUTATION ESTADO DE PAYLOAD MANAGE UNIDADES
    setPayloadManageUnidades(state, payload) {
        state.payloadManageUnidades = payload
    },

    //-- MUTATION ESTADO DE PAYLOAD MANAGE TURMAS
    setPayloadManageTurmas(state, payload) {
        state.payloadManageTurmas = payload
    },
    
}

// ACTIONS
const actions = {

    setHistoryBack({commit},payload){
        commit('setHistory', payload);
    },

    //-- ACTION REQUISICAO CRIAR AMOSTRA/CAMPO -  OK,ATUALIZADO!
    async setCreateCampo({ commit },payload,)  {
        await axios
            .post(`campos/${payload.idMunicipio}`, {
                titulo: payload.titulo,
                ano: payload.ano,
                descricao: payload.descricao
            },
                {headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then((response) => {
                commit('setIdCampo', response.data.data.idCampo);
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTCAMPOS (AMOSTRAS) - OK,ATUALIZADO!
    async setListCampos({ commit }, idMunicipio) {
        await axios
            .get(`campos/${idMunicipio}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListCampos', response.data)
            })
            .catch((error) => console.log(error.message))

    },

    async setEncerraCampo( _, payload)  {
        await axios
            .put(`campos/${payload.idMunicipio}/${payload.idCampo}`, {
                estaAtiva: "OFF"
            },
                {headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {})
            .catch((error) => console.log(error.message))
    },

    async setIniciaCampo( _, payload)  {
        await axios
            .put(`campos/${payload.idMunicipio}/${payload.idCampo}`, {
                estaAtiva: "ON"
            },
                {headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {})
            .catch((error) => console.log(error.message))
    },

    //-- ACTION DELETE CAMPO/AMOSTRA - OK,ATUALIZADO!
    async deleteCampo(_, payload) {
        await axios
            .delete(`campos/${payload.idMunicipio}/${payload.idCampo}`,{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() =>{
            })
            .catch((error) => console.log(error.message))
    },


    //-- ACTION REQUISICAO DO LISTCAMPOMEMBROS (APLICADORES)
    async setListCampoMembros({ commit }, payload) {
        await axios
            .get(`campos/aplicadores/${payload.idMunicipio}/${payload.idCampo}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListCampoMembros', response.data)
            })
            .catch((error) => console.log(error.message))

    },

    //-- ACTION REQUISICAO DO LISTCAMPOFORMULARIOS - OK!
    async setListCampoFormularios({ commit }, payload) {
        await axios
            .get(`campos/formularios/${payload.idMunicipio}/${payload.idCampo}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListCampoFormularios', response.data)
            })
            .catch((error) => console.log(error.message))

    },

    //-- ACTION REQUISICAO DO LISTCAMPOUNIDADESEDUCACIONAIS
    async setListCampoUEs({ commit }, payload) {
        await axios
            .get(`campos/unidades/${payload.idMunicipio}/${payload.idCampo}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListCampoUEs', response.data)
            })
            .catch((error) => console.log(error.message))

    },

    //-- ACTION REQUISICAO DO LISTCAMPOTURMAS
    async setListCampoTurmas({ commit }, payload) {
        await axios
            .get(`campos/turmas/${payload.idMunicipio}/${payload.idCampo}/${payload.idUnidade}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListCampoTurmas', response.data)
            })
            .catch((error) => console.log(error.message))

    },

    //-- ACTION REQUISICAO DE MANAGE APLICADORES
    async setManageAplicadores(_, payload) {
        await axios
            .post(`campos/manageAplicadores/${payload.idMunicipio}/${payload.idCampo}`, {
                    ids: payload.ids
            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))

    },

    //-- ACTION REQUISICAO DE MANAGE FORMULARIOS
    async setManageFormularios(_, payload) {
        await axios
            .post(`campos/manageFormularios/${payload.idMunicipio}/${payload.idCampo}`, {
                    ids: payload.ids
            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))

    },

    //-- ACTION REQUISICAO DE MANAGE UNIDADES
    async setManageUnidades(_, payload) {
        await axios
            .post(`campos/manageUnidades/${payload.idMunicipio}/${payload.idCampo}`, {
                    ids: payload.ids
            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))

    },

    //-- ACTION REQUISICAO DE MANAGE TURMAS
    async setManageTurmas(_, payload) {
        await axios
            .post(`campos/manageTurmas/${payload.idMunicipio}/${payload.idCampo}/${payload.idUnidade}`, {
                    ids: payload.ids
            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))

    },

}

// GETTERS
const getters = {
    getListCampos(state) {
        try {
            return state.listCampos.data
        } catch (e) {
            return []
        }
    },

    getListCampoMembros(state) {
        try {
            return state.listCampoMembros.data
        } catch (e) {
            return []
        }
    },

    getListCampoFormularios(state) {
        try {
            return state.listCampoFormularios.data
        } catch (e) {
            return []
        }
    },

    getListCampoUEs(state) {
        try {
            return state.listCampoUEs.data
        } catch (e) {
            return []
        }
    },

    getListCampoTurmas(state) {
        try {
            return state.listCampoTurmas.data
        } catch (e) {
            return []
        }
    },

    getPayloadManageAplicadores(state) {
        return state.payloadManageAplicadores
    },

    getPayloadManageFormularios(state) {
        return state.payloadManageFormularios
    },

    getPayloadManageUnidades(state) {
        return state.payloadManageUnidades
    },

    getPayloadManageTurmas(state) {
        return state.payloadManageTurmas
    },

    getAmostraStatusAtiva(state) {
        return state.getAmostraStatusAtiva
    },

    getIdCampo(state){
        return state.idCampo
    },

    getHistory(state){
        return state.history
    }
    
}

export default {
    state,
    mutations,
    actions,
    getters
}
